const notifications = {
  moduleTitle: "الإشعارات",
  title: "الإشعارات",
  markAllAsRead: "تحديد الكل كمقروء",
  empty: "لا توجد إشعارات حتى الآن.",
  error: "تعذر تحميل الإشعارات.",
  loading: "جارٍ تحميل الإشعارات",
  bellLabelWithCount: "الإشعارات، {{count}} غير مقروءة",
  enablePush: "تفعيل إشعارات الدفع",
  category: {
    alert: "تنبيه",
    system: "نظام",
    subscription: "اشتراك",
    maintenance: "صيانة",
  },
  permissions: {
    core: "أساسي",
    management: "إدارة الإشعارات",
    notifications: "الإشعارات",
  },
  actions: {
    view: "عرض الإشعارات",
  },
};

export default notifications;
